export default () => ({
  container: {
    padding: 5,
  },
});
